import { Form, Formik } from "formik";
import { preparationValidation } from "../../../helpers/validationSchemes";
import { editProject } from "../../../api/project";
import { Grid, Button, Typography, Box, Divider } from "@mui/material";
import ActivitiesField from "../../Reuseables/Fields/ActivitiesField";
import NotStartedViewIntro from "./NotStartedViewIntro";
import { useTranslation } from "react-i18next";
import { DialogLeavingPage } from "../../Reuseables/Dialogs/LeavingPageDialog";
import { useApplicationContext } from "../../ContextProviders/ApplicationContext";
import { Project } from "../../../types/project";
import CreateUserAccountsPopup from "../../Reuseables/CreateUserAccountsPopup";
import { useState } from "react";
import { useOrganizationContext } from "../../ContextProviders/OrganizationContext";

type NotStartedViewProps = {
  project: Project;
};

export default function NotStartedView({ project }: NotStartedViewProps) {
  const { t } = useTranslation();
  const { showSnackbar } = useApplicationContext();
  const { updateProject } = useOrganizationContext();
  const [createUserPopup, setCreateUserPopup] = useState(false);
  const handleCreateUserPopupClose = () => {
    setCreateUserPopup(false);
  };
 
  const _saveChanges = async (values: Project) => {
    try {
      let response = await editProject(values);
      updateProject(response);
      showSnackbar(t("dialogs.successText1"), "success");
    } catch (error: unknown) {
      if (error instanceof Error) {
        showSnackbar(error.message, "error");
      } else {
        showSnackbar("Unknown error", "error");
      }
    }
  };

  return (
    <Formik
      key={project.projectCode}
      initialValues={project}
      validateOnBlur={false}
      validationSchema={preparationValidation}
      onSubmit={async (values, actions) => {
        let possibleErrors = await actions.validateForm();

        if (Object.keys(possibleErrors).length === 0) {
          _saveChanges(values);
          actions.resetForm({ values });
        } else {
          // Manually set touched fields to true for validation errors
          const touchedFields = Object.keys(possibleErrors).reduce(
            (acc: any, key) => {
              acc[key] = true;
              return acc;
            },
            {}
          );

          actions.setTouched(touchedFields);
        }
      }}
    >
      {(props) => (
        <Form id={project.projectCode}>
          <Grid
            key={project.projectCode}
            container
            mt={4}
            minHeight="60vh"
            mb={2}
            sx={{
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "column",
                lg: "row",
              },
            }}
          >
            <Grid item xs>
              <Grid container>
                <Grid item flexGrow={1}/>
                <Grid item xs={12} sm={8} md={10} lg={10} xl={8}>
                  <NotStartedViewIntro project={project} />
                </Grid>
                <Grid item flexGrow={1}/>
              </Grid>
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item xs>
              <Grid container>
              <Grid item flexGrow={1}/>
                <Grid item xs={12} sm={8} md={10} lg={10} xl={8}>
                  <Box mt={5}>
                    <Box mt={5}>
                      <Typography>{t("notStartedPage.text9")}</Typography>
                    </Box>
                    <Box mt={2}>
                      <Typography color={"primary"}>
                        {t("labels.activities")}:
                      </Typography>
                    </Box>
                  </Box>

                  <Box mt={2}>
                    <ActivitiesField />
                  </Box>

                  <>
                    <DialogLeavingPage />
                    <CreateUserAccountsPopup  handleClose={handleCreateUserPopupClose} isDialogOpen={createUserPopup} project={project}/>
                    <Button variant="contained" onClick={() => setCreateUserPopup(true)}>Create user accounts</Button>
                    <Button
                      variant="contained"
                      sx={{ float: "right" }}
                      disabled={!props.dirty}
                      type="submit"
                    >
                      {t("buttons.saveChanges")}
                    </Button>
                  </>
                </Grid>
                <Grid item flexGrow={1}/>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}
